import * as React from "react";

import { ARTICLE_TYPE, Story } from "~types/types";

export type CurrentStoryContextValue = {
    story: Story;
    articleType: ARTICLE_TYPE;
};

export const CurrentStoryContext =
    React.createContext<CurrentStoryContextValue>({
        story: {} as Story,
        articleType: ARTICLE_TYPE.BASIC,
    });
